import PropTypes from 'prop-types';
import BodyCopy from '../ui/BodyCopy/BodyCopy';
import ShippingDetailsStyles from './ShippingDetails.style';

const ShippingDetails = ({ availabilityLabels }) => {
  const { pickUpFromStoreShipping, homeDeliveryShipping, expressShipping } = availabilityLabels;

  return (
    <ul className="shipping-details">
      {expressShipping && (
        <li className="shipping-wrapper">
          <span className="express-icon" />
          <BodyCopy size="copy4">
            {(cl) => <span dangerouslySetInnerHTML={{ __html: expressShipping }} className={`${cl}`} />}
          </BodyCopy>
        </li>
      )}
      {homeDeliveryShipping && (
        <li className="shipping-wrapper">
          <span className="scheduled-icon" />
          <BodyCopy size="copy4">{(cl) => <span className={`${cl}`}>{homeDeliveryShipping}</span>}</BodyCopy>
        </li>
      )}
      {pickUpFromStoreShipping && (
        <li className="shipping-wrapper">
          <span className="store-icon" />
          <BodyCopy size="copy4">{(cl) => <span className={`${cl}`}>{pickUpFromStoreShipping}</span>}</BodyCopy>
        </li>
      )}
      <style jsx>{ShippingDetailsStyles}</style>
    </ul>
  );
};

ShippingDetails.propTypes = {
  availabilityLabels: PropTypes.shape({
    homeDeliveryShipping: PropTypes.string,
    pickUpFromStoreShipping: PropTypes.string,
    expressShipping: PropTypes.string,
  }),
};

ShippingDetails.defaultProps = {
  availabilityLabels: {},
};

export { ShippingDetails };
